import { getRuntimeConfigValue } from './runtime-config';

export interface EnvironmentIndicator {
  label: 'LOCAL' | 'DEV';
  backgroundColor: '#DCFCE7' | '#a5f3fc';
  badgeColor: '#14532d' | '#1e3a8a';
}

export function resolveEnvironmentIndicator(
  rawEnv: string | undefined,
  isDevMode = import.meta.env.DEV
): EnvironmentIndicator | null {
  const normalized = rawEnv?.trim().toLowerCase();

  if (!normalized && isDevMode) {
    return { label: 'LOCAL', backgroundColor: '#DCFCE7', badgeColor: '#14532d' };
  }

  if (normalized === 'local') {
    return { label: 'LOCAL', backgroundColor: '#DCFCE7', badgeColor: '#14532d' };
  }

  if (normalized === 'dev' || normalized === 'development') {
    return { label: 'DEV', backgroundColor: '#a5f3fc', badgeColor: '#1e3a8a' };
  }

  return null;
}

export function getEnvironmentIndicator(): EnvironmentIndicator | null {
  return resolveEnvironmentIndicator(getRuntimeConfigValue('VITE_APP_ENV'));
}
